import { USER_INITIAL_PERMISSION } from '../../../../../constants/service/common/userPermissions';

export const ADMIN_LEVEL_TYPE = {
  /**
   *  최상위 관리자
   */
  MASTER: 1,
  /**
   *  일반 관리자
   */
  GENERAL: 0,
};

export const ADMIN_LEVEL_TYPE_TEXT = {
  [ADMIN_LEVEL_TYPE.MASTER]: '최상위 관리자',
  [ADMIN_LEVEL_TYPE.GENERAL]: '일반 관리자',
} as const;

export const ADMIN_LEVEL_TYPE_LIST = [
  {
    id: ADMIN_LEVEL_TYPE.GENERAL,
    name: ADMIN_LEVEL_TYPE_TEXT[ADMIN_LEVEL_TYPE.GENERAL],
  },
  {
    id: ADMIN_LEVEL_TYPE.MASTER,
    name: ADMIN_LEVEL_TYPE_TEXT[ADMIN_LEVEL_TYPE.MASTER],
  },
];

export enum AdminStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const ADMIN_STATUS_TYPE_TEXT: Record<AdminStatus, string> = {
  [AdminStatus.ACTIVE]: '활성',
  [AdminStatus.INACTIVE]: '비활성',
} as const;

export const ADMIN_STATUS_TYPE_LIST = [
  {
    id: AdminStatus.ACTIVE,
    name: ADMIN_STATUS_TYPE_TEXT[AdminStatus.ACTIVE],
  },
  {
    id: AdminStatus.INACTIVE,
    name: ADMIN_STATUS_TYPE_TEXT[AdminStatus.INACTIVE],
  },
];

export const AccountAdminCreateSuccess = '신규 관리자를 등록 완료했습니다.';
export const AccountAdminEditSuccess = '관리자 정보를 편집 완료했습니다.';
export const AccountAdminInfoReadSuccess = '관리자 정보를 불러왔습니다.';

export const FORM_DEFAULT_VALUE = {
  email: '',
  name: '',
  phone: '',
  password: '',
  passwordConfirm: '',
  level: ADMIN_LEVEL_TYPE.GENERAL,
  status: AdminStatus.ACTIVE,
  permission: USER_INITIAL_PERMISSION,
};

export const ACCOUNT_ADMIN_LIST_PAGINATION_MODEL = {
  pageIndex: 1,
  pageSize: 100,
};

/**
 *  관리자 리스트 필터 옵션 모델
 */
export const ACCOUNT_ADMIN_LIST_FILTER_OPTION_MODEL = {
  /**
   *  회원번호
   */
  id: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  이름
   */
  name: null,
  /**
   *  핸드폰
   */
  phone: null,
  /**
   *  권한
   */
  level: null,
  /**
   *  활성화 상태
   */
  status: null,
};

export const ACCOUNT_ADMIN_LIST_SORT_OPTION_MODEL = {
  sort: '',
};
